module.exports = __webpack_public_path__ + "img/img_payco.6610d6ee.png";